module.exports = __webpack_public_path__ + "static/media/header.ab1e34cc.svg";